import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Checkbox,
  Chip,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  Input,
  MenuItem,
  Select,
  TextField,
  Typography,
  Radio,
} from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Loader } from "../../helpers";
import { CalendarMonth } from "@mui/icons-material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { UploadMedia } from "utils/mediaUpload";
import { GridCloseIcon } from "@mui/x-data-grid";
import useAuth from "hooks/useAuth";
import {
  useAddVehicleMutation,
  useUpdateVechileMutation,
  useLazyGetVechileByIdQuery,
  useLazyGetAllCitsQuery,
} from "service/vehicles";
import { generateEncryptedKeyBody } from "utils/crypto";
import { CommonBody } from "types/General";
import { showError, showToast } from "../../helpers/showToast";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import {
  useLazyGetAllBrandsQuery,
  useLazyGetAllCategoryQuery,
  useLazyGetAllClassesQuery,
} from "service/category";
import { useLazyGetAllPartnersQuery } from "service/partner";
import { isNumber } from "utils/validations";
import { APPROVAL_STATUS, VEHICLE_CONDITION } from "utils/enums";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";

interface PricingData {
  price: string;
  mileage: string;
}

const allRentalTypes = ["daily", "weekly", "monthly", "corporate"];

const AddVehicle = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const userData = useAuth();
  const [addVehicle] = useAddVehicleMutation();
  const [getCategories] = useLazyGetAllCategoryQuery();
  const [getBrands] = useLazyGetAllBrandsQuery();
  const [getClasses] = useLazyGetAllClassesQuery();
  const [getPartners] = useLazyGetAllPartnersQuery();
  const [getVechileByID] = useLazyGetVechileByIdQuery();
  const [udateVechile] = useUpdateVechileMutation();
  const [getCities] = useLazyGetAllCitsQuery();
  const [partners, setPartners] = useState<any[]>([]);
  const [partnersLoading, setPartnersLoading] = useState(false);
  const [vehicleDetails, setVehicleDetails] = useState<any[]>([]);

  const availabilityOptions = [
    { id: "daily", label: "Daily Rental", icon: "📅" },
    { id: "weekly", label: "Weekly Rental", icon: "📆" },
    { id: "monthly", label: "Monthly Rental", icon: "🗓️" },
    { id: "corporate", label: "Corporate Rental", icon: "🏢" },
  ];

  const [loading, setLoading] = useState(false);
  const [carImages, setCarImages] = useState<string[]>([]);
  const [selectedAvailability, setSelectedAvailability] = useState<string[]>(
    []
  );
  const [pricing, setPricing] = useState<Record<string, PricingData>>({});
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCities, setSelectedCities] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSeats, setSelectedSeats] = useState("");
  const [model, setModel] = useState<Dayjs | null>(null);
  const [selectedOwner, setSelectedOwner] = useState("");
  const [selectedUser, setSelectedUser] = useState("default");

  const [selectedTransmission, setSelectedTransmission] = useState("");
  const [selectedFuelType, setSelectedFuelType] = useState("");
  const [selectedCondition, setSelectedCondition] = useState("");
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [classes, setClasses] = useState([]);
  const [error, setError] = useState(false);
  const [cities, setCities] = useState<any[]>([]);
  const [vehicleDocUrl, setVehicleDocUrl] = useState<string>("");
  const [ownerDocUrl, setOwnerDocUrl] = useState<string>("");

  const handleCategoryChange = (event: any) => {
    setSelectedCategory(event.target.value);
  };
  const handleCitiesChange = (event: any) => {
    setSelectedCities(event.target.value);
  };

  const handleBrandChange = (event: any) => {
    setSelectedBrand(event.target.value);
  };

  const handleClassChange = (event: any) => {
    setSelectedClass(event.target.value);
  };

  const handleOwnerChange = (event: any) => {
    setSelectedOwner(event.target.value);
  };

  const handlePartnerChange = (event: any) => {
    setSelectedUser(event.target.value);
  };

  const handleTransmissionChange = (event: any) => {
    setSelectedTransmission(event.target.value);
  };

  const handleSeatsChange = (event: any) => {
    setSelectedSeats(event.target.value);
  };

  const handleFuelChange = (event: any) => {
    setSelectedFuelType(event.target.value);
  };

  const handleConditionChange = (event: any) => {
    setSelectedCondition(event.target.value);
  };

  const getCategoriesApi = async () => {
    setLoading(true);
    try {
      const response = await getCategories({
        page: 1,
        search: "",
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setCategories(response?.data?.list);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const handleAvailabilityChange = (optionId: string) => {
    setSelectedAvailability((prev) =>
      prev.includes(optionId)
        ? prev.filter((id) => id !== optionId)
        : [...prev, optionId]
    );
  };

  const handleAllAvailabilityChange = () => {
    if (selectedAvailability.length === availabilityOptions.length) {
      setSelectedAvailability([]);
    } else {
      setSelectedAvailability(availabilityOptions.map((opt) => opt.id));
    }
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      const invalidFiles = Array.from(files).filter(
        (file: any) => !allowedTypes.includes(file.type)
      );
      if (invalidFiles.length > 0) {
        showError("Invalid image please upload again");
        return;
      }
      if (carImages?.length + files.length > 5) {
        showError("Maximum 5 images allowed");
        return;
      }
      const uploadedImages = Array.from(files).map((file: any) => ({
        file,
        url: URL.createObjectURL(file),
      }));
      setCarImages((prevImages: any) => [...prevImages, ...uploadedImages]);
    }
  };
  const handlePricingChange = (
    optionId: string,
    field: keyof PricingData,
    value: string
  ): void => {
    setPricing({
      ...pricing,
      [optionId]: {
        ...pricing[optionId],
        [field]: value,
      },
    });
  };

  const handleVehicleDocUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoading(true);
    const file = event.target.files?.[0];
    if (!file) return setLoading(false);
    try {
      const res = await UploadMedia(file);
      const imageUrl = res?.data?.image;
      if (imageUrl) {
        setVehicleDocUrl(imageUrl);
        showToast("Vehicle document uploaded successfully.");
      }
    } catch {
      showError("Error uploading vehicle document.");
    }
    setLoading(false);
  };

  const handleOwnerDocUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoading(true);
    const file = event.target.files?.[0];
    if (!file) return setLoading(false);
    try {
      const res = await UploadMedia(file);
      const imageUrl = res?.data?.image;
      if (imageUrl) {
        setOwnerDocUrl(imageUrl);
        showToast("Owner document uploaded successfully.");
      }
    } catch {
      showError("Error uploading owner document.");
    }
    setLoading(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      registrationNumber: "",
      mileage: "",
      deliveryFees: "",
      securityCharges: "",
      returnCharges: "",
      description: "",
      depositFee: "",
      isDepositRequired: false,
      extraCharge: "",
      startDate: "",
      endDate: "",
      isSubscription: false,
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required("This field is required")
        .min(2, "Minimum 2 characters are required"),
      registrationNumber: Yup.string().required("This field is required"),
      mileage: Yup.string().required("This field is required"),
      deliveryFees: Yup.string().required("This field is required"),
      securityCharges: Yup.string().required("This field is required"),
      returnCharges: Yup.string().required("This field is required"),
      extraCharge: Yup.string().required("This field is required"),
      description: Yup.string()
        .required("This field is required")
        .min(2, "Minimum 2 characters are required"),
    }),
    onSubmit: async (values: any) => {
      if (selectedOwner === "2" && (!selectedUser || selectedUser === "")) {
        setError(true);
        showError("Please select a partner");
        return;
      }
      formik.setSubmitting(true);

      let images: any[] = [];
      if (carImages?.length) {
        await Promise.all(
          carImages?.map(async (item: any) => {
            if (item?.id) {
              images?.push(item.id);
            } else {
              const res = await UploadMedia(item?.file);
              if (res?.statusCode === 200) {
                images?.push(res.data?.image);
              }
            }
          })
        );
      }

      if (!id && !images?.length) {
        showError("Please upload images");
        return;
      }
      if (!selectedBrand) return;
      if (!selectedCategory) return;
      if (!selectedClass) return;
      if (!selectedTransmission) return;
      if (!selectedFuelType) return;
      if (!selectedCondition) return;
      if (!model) return;
      if (!selectedOwner) return;
      if (!selectedCities) return;

      if (selectedOwner === "2" && (!vehicleDocUrl || !ownerDocUrl)) {
        setError(true);
        showError("Both vehicle and owner documents are required");
        return;
      }

      const rentalPolicy: Record<
        string,
        { minDays: number; mileageLimit: number }
      > = {};
      selectedAvailability.forEach((type) => {
        rentalPolicy[type] = {
          minDays: type === "daily" ? 1 : type === "weekly" ? 7 : 30,
          mileageLimit: Number(pricing[type]?.mileage),
        };
      });
      const rentalTypes = Object.fromEntries(
        allRentalTypes.map((type) => [
          type,
          selectedAvailability.includes(type),
        ])
      );
      const basePricing: any = {
        currency: 1,
        ...(values?.isDepositRequired ? { depositFee: values.depositFee } : {}),
        ...(values?.isDepositRequired ? { isDepositRequired: true } : {}),
        securityCharge: values.securityCharges,
        extraMileageCharge: 2,
      };
      selectedAvailability.forEach((type) => {
        basePricing[type] = pricing[type]?.price;
      });
      const body = {
        addedByType: Number(selectedOwner),
        addedBy: selectedOwner === "1" ? userData?._id : selectedUser,
        partnerId: selectedOwner === "1" ? userData?._id : selectedUser,
        title: {
          en: values?.name,
        },
        description: {
          en: values.description,
        },
        brand: selectedBrand,
        category: selectedCategory,
        car_class: selectedClass,
        registrationNumber: values.registrationNumber,
        location: {
          city: selectedCities,
          coordinates: {
            type: "Point",
            coordinates: [77.5946, 12.9716],
          },
        },
        specs: {
          transmission: selectedTransmission,
          seats: selectedSeats,
          fuelType: selectedFuelType,
          modelYear: dayjs(model).format("YYYY"),
          condition: selectedCondition,
        },
        basePricing,
        deliveryCharges: {
          deliveryFee: values.deliveryFees,
          returnFee: values.returnCharges,
        },
        rentalPolicy,
        availability: {
          isAvailable: true,
          isVerified: true,
          rentalTypes: rentalTypes,
          availableFrom: values.startDate,
          availableTo: values.endDate,
        },
        flags: {
          isFeatured: true,
          isPopular: false,
        },
        images: images,
        documents: {
          vehicleDocuments: vehicleDocUrl,
          ownerDocuments: ownerDocUrl,
        },
        forSubscription: values.isSubscription,
      };

      // return;
      console.log("====================================");
      console.log(body, "DATA");
      console.log("====================================");

      try {
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        let response;
        let isUpdate = false;

        if (id) {
          response = await udateVechile({ body: encryptedBody, id }).unwrap();
          isUpdate = true;
        } else {
          response = await addVehicle({ body: encryptedBody }).unwrap();
        }

        if (response?.statusCode === 200) {
          showToast(
            isUpdate
              ? "Vehicle updated successfully"
              : "Vehicle added successfully"
          );
          navigate("/listings/individual");
        }
      } catch (error: any) {
        showError(error?.data?.message || "Failed to process vehicle request");
        console.error(error);
      }
    },
  });

  const getBrandApi = async () => {
    setLoading(true);
    try {
      const response = await getBrands({
        page: 1,
        search: "",
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setBrands(response?.data?.brands);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getCitiesApi = async () => {
    setLoading(true);
    try {
      const response = await getCities({}).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setCities(response?.data?.result);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getClassApi = async () => {
    setLoading(true);
    try {
      const response = await getClasses({
        page: 1,
        search: "",
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setClasses(response?.data?.Classs);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const fetchPartners = async () => {
    if (selectedOwner === "2") {
      setPartnersLoading(true);
      try {
        const response = await getPartners({
          page: 1,
          search: "",
          status: APPROVAL_STATUS.APPROVED,
        }).unwrap();
        setPartnersLoading(false);
        if (response.statusCode === 200) {
          setPartners(response?.data?.list || []);
        } else {
          setPartners([]);
        }
      } catch (error) {
        setPartnersLoading(false);
        setPartners([]);
      }
    } else {
      setPartners([]);
    }
  };

  const getDataByIdList = async () => {
    try {
      setLoading(true);
      if (!id) return;
      const response = await getVechileByID({ id }).unwrap();
      if (response.statusCode == 200) {
        setVehicleDetails(response?.data?.vehicles[0]);
        const vehicleDetails = response?.data?.vehicles[0];
        setVehicleDocUrl(vehicleDetails?.documents?.vehicleDocuments || "");
        setOwnerDocUrl(vehicleDetails?.documents?.ownerDocuments || "");
        setSelectedBrand(vehicleDetails?.brandDetail?._id || "");
        setSelectedCategory(vehicleDetails?.categoryDetails?._id || "");
        setSelectedClass(vehicleDetails?.classDetails?._id || "");
        setSelectedSeats(vehicleDetails?.specs?.seats?.toString() || "");

        if (
          vehicleDetails?.specs?.modelYear &&
          !isNaN(Number(vehicleDetails?.specs?.modelYear))
        ) {
          setModel(dayjs(`${vehicleDetails?.specs?.modelYear}-01-01`)); // Safe: "2025-01-01"
        } else {
          setModel(null);
        }
        setSelectedCities(vehicleDetails?.location?.city || "");
        setSelectedTransmission(vehicleDetails?.specs?.transmission || "");
        setSelectedFuelType(vehicleDetails?.specs?.fuelType || "");
        setSelectedCondition(String(vehicleDetails?.specs?.condition) || "");
        setSelectedOwner(
          vehicleDetails?.addedByType === "admin"
            ? "1"
            : vehicleDetails?.addedByType === "partner"
              ? "2"
              : vehicleDetails?.addedByType?.toString() || ""
        );
        setSelectedUser(vehicleDetails?.addedBy || "");
        const rentalTypesObj = vehicleDetails?.availability?.rentalTypes || {};
        const selectedAvail = Object.keys(rentalTypesObj).filter(
          (key) => rentalTypesObj[key]
        );
        setSelectedAvailability(selectedAvail);
        const pricingObj: Record<string, PricingData> = {};
        Object.keys(rentalTypesObj).forEach((type) => {
          if (rentalTypesObj[type]) {
            pricingObj[type] = {
              price:
                vehicleDetails?.basePricing?.[type]?.toString?.() ||
                vehicleDetails?.basePricing?.[type] ||
                "",
              mileage:
                vehicleDetails?.rentalPolicy?.[
                  type
                ]?.mileageLimit?.toString?.() ||
                vehicleDetails?.rentalPolicy?.[
                  type
                ]?.mileageLimit?.toString() ||
                "",
            };
          }
        });
        setPricing(pricingObj);
        setCarImages(
          (vehicleDetails?.images || []).map((img: string) => ({
            url: img,
            id: img,
          }))
        );

        formik.setValues({
          name: vehicleDetails?.title?.en || "",
          registrationNumber: vehicleDetails?.registrationNumber || "",
          mileage:
            vehicleDetails?.rentalPolicy?.daily?.mileageLimit?.toString() || "",
          deliveryFees:
            vehicleDetails?.deliveryCharges?.deliveryFee?.toString() || "",
          securityCharges:
            vehicleDetails?.basePricing?.securityCharge?.toString() || "",
          returnCharges:
            vehicleDetails?.deliveryCharges?.returnFee?.toString() || "",
          description: vehicleDetails?.description?.en || "",
          depositFee: vehicleDetails?.basePricing?.depositFee?.toString() || "",
          isDepositRequired:
            vehicleDetails?.basePricing?.isDepositRequired || false,
          extraCharge:
            vehicleDetails?.basePricing?.extraMileageCharge?.toString() || "",
          startDate:
            vehicleDetails?.availability?.availableFrom?.split("T")[0] || "",
          endDate:
            vehicleDetails?.availability?.availableTo?.split("T")[0] || "",
          isSubscription: vehicleDetails?.forSubscription,
        });
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      showError(error?.message || error?.data?.message);
    }
  };

  console.log("====================================");
  console.log(selectedCondition, "OKOKOKo");
  console.log("====================================");
  useEffect(() => {
    if (id) {
      getDataByIdList();
    }
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    getCategoriesApi();
    getBrandApi();
    getClassApi();
    fetchPartners();
    getCitiesApi();
  }, [selectedOwner, getPartners]);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title fdx">
        <div>
          <h1>{id ? "Edit" : "Add"} Vehicle</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/listings/myList")}>
              My Listings
            </span>{" "}
            - {id ? "Edit" : "Add"} Vehicle
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="gap_p">
            <div className="control_group w_100">
              <label>Upload Images</label>
              {carImages?.length >= 5 ? null : (
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    flexWrap: "nowrap",
                    marginTop: 8,
                    marginBottom: 20,
                    // overflowX: "auto",
                    alignItems: "center",
                  }}
                >
                  <label
                    className="upload_image no_radius v2"
                    htmlFor="icon-button-file"
                    style={{
                      cursor: "pointer",
                      width: 300,
                      height: 150,
                      minWidth: 120,
                      minHeight: 120,
                      border: "1.5px dashed #ccc",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "#f5f5f5",
                      flex: "0 0 auto",
                    }}
                  >
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                        multiple: true,
                      }}
                      onChange={handleFileUpload}
                    />
                    <span
                      className="upload_image_holder"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src="/static/images/picture.png"
                        alt="icon"
                        style={{ width: 40, height: 40, opacity: 0.5 }}
                      />
                      <span className="upload_img_icon">
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="icon"
                          style={{ width: 24, height: 24 }}
                        />
                      </span>
                    </span>
                  </label>
                </div>
              )}

              {carImages?.map((img: any, idx) => (
                <div
                  key={idx}
                  className="upload_image no_radius v2"
                  style={{
                    position: "relative",
                    width: 200,
                    height: 100,
                    minWidth: 120,
                    minHeight: 120,
                    border: "1.5px solid #ccc",

                    overflow: "visible",
                    background: "#fff",
                    flex: "0 0 auto",
                    marginRight: 20,
                  }}
                >
                  <IconButton
                    size="small"
                    style={{
                      position: "absolute",
                      top: -10,
                      right: -10,
                      background: "#006039",
                      color: "#fff",
                      zIndex: 2,
                      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                      width: 28,
                      height: 28,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() =>
                      setCarImages(carImages?.filter((_, i) => i !== idx))
                    }
                  >
                    <GridCloseIcon fontSize="small" />
                  </IconButton>
                  <div
                    className="upload_image_holder"
                    style={{ width: "100%", height: "100%" }}
                  >
                    <CardMedia
                      component="img"
                      image={img?.url || ""}
                      alt={""}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="control_group w_50">
              <label>Name</label>
              <TextField
                variant="outlined"
                placeholder="Name"
                fullWidth
                hiddenLabel
                className="text_field"
                name="name"
                id="name"
                value={formik.values.name}
                onChange={(val) => {
                  if (val.target.value === " " || val.target.value === ".") {
                  } else {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.name}
                helperText={formik.touched.name && formik.errors.name}
              />
            </div>

            <div className="control_group w_50">
              <label>Brand</label>
              <Select
                fullWidth
                labelId="condition"
                name="condition"
                value={selectedBrand}
                displayEmpty
                onChange={handleBrandChange}
              >
                <MenuItem disabled value="">
                  Select Brand
                </MenuItem>

                {brands?.length
                  ? brands?.map((item: any) => (
                      <MenuItem key={item?._id} value={item?._id}>
                        {item?.name?.en || ""}
                      </MenuItem>
                    ))
                  : null}
              </Select>
              {error && !selectedBrand ? (
                <p className="err_msg">Brand is required</p>
              ) : (
                ""
              )}
            </div>

            <div className="control_group w_50">
              <label>Category</label>
              <Select
                fullWidth
                labelId="category"
                name="category"
                value={selectedCategory}
                displayEmpty
                onChange={handleCategoryChange}
              >
                <MenuItem disabled value="">
                  Select Category
                </MenuItem>
                {categories?.length
                  ? categories?.map((item: any) => (
                      <MenuItem key={item?._id} value={item?._id}>
                        {item?.name?.en || ""}
                      </MenuItem>
                    ))
                  : null}
              </Select>
              {error && !selectedCategory ? (
                <p className="err_msg">Category is required</p>
              ) : (
                ""
              )}
            </div>

            <div className="control_group w_50">
              <label>Class Type</label>
              <Select
                fullWidth
                labelId="class"
                name="class"
                value={selectedClass}
                displayEmpty
                onChange={handleClassChange}
              >
                <MenuItem disabled value="">
                  Select Class
                </MenuItem>

                {classes?.length
                  ? classes?.map((item: any) => (
                      <MenuItem key={item?._id} value={item?._id}>
                        {item?.name?.en || ""}
                      </MenuItem>
                    ))
                  : null}
              </Select>
              {error && !selectedClass ? (
                <p className="err_msg">Class is required</p>
              ) : (
                ""
              )}
            </div>

            <div className="control_group w_50">
              <label>Number of Seats</label>
              <Select
                fullWidth
                labelId="seats"
                name="seats"
                value={selectedSeats}
                displayEmpty
                onChange={handleSeatsChange}
              >
                <MenuItem disabled value="">
                  Select Seats
                </MenuItem>

                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={7}>7</MenuItem>
              </Select>
              {error && !selectedSeats ? (
                <p className="err_msg">Seats is required</p>
              ) : (
                ""
              )}
            </div>

            <div className="control_group w_50">
              <label>Transmission</label>
              <Select
                fullWidth
                labelId="transmission"
                name="transmission"
                value={selectedTransmission}
                displayEmpty
                onChange={handleTransmissionChange}
              >
                <MenuItem disabled value="">
                  Select Transmission
                </MenuItem>

                <MenuItem value={1}>Manual</MenuItem>
                <MenuItem value={2}>Automatic</MenuItem>
              </Select>
              {error && !selectedTransmission ? (
                <p className="err_msg">Transmission is required</p>
              ) : (
                ""
              )}
            </div>

            <div className="control_group w_50">
              <label>Fuel Type</label>
              <Select
                fullWidth
                labelId="condition"
                name="condition"
                displayEmpty
                value={selectedFuelType}
                onChange={handleFuelChange}
                // onBlur={formik.handleBlur}
                // error={formik.touched.condition && Boolean(formik.errors.condition)}
              >
                <MenuItem disabled value="">
                  Select Fuel Type
                </MenuItem>

                <MenuItem value={1}>Petrol</MenuItem>
                <MenuItem value={2}>Diesel</MenuItem>
                <MenuItem value={3}>Electric</MenuItem>
                <MenuItem value={4}>Hybrid</MenuItem>
              </Select>
              {error && !selectedFuelType ? (
                <p className="err_msg">Fuel Type is required</p>
              ) : (
                ""
              )}
            </div>

            {/* Condition Select */}

            <div className="control_group w_50">
              <label>Condition</label>
              <Select
                fullWidth
                labelId="condition"
                name="condition"
                value={selectedCondition}
                displayEmpty
                onChange={(e) => handleConditionChange(e)}
              >
                <MenuItem disabled value="">
                  Select Condition
                </MenuItem>
                <MenuItem value="1">New</MenuItem>
                <MenuItem value="2">Old</MenuItem>
              </Select>
              {error && !selectedCondition ? (
                <p className="err_msg">Condition is required</p>
              ) : (
                ""
              )}
            </div>

            <div className="control_group w_50">
              <label>Vehicle registration number</label>
              <TextField
                variant="outlined"
                placeholder="Vehicle registration number"
                fullWidth
                hiddenLabel
                className="text_field"
                name="registrationNumber"
                id="registrationNumber"
                inputProps={{ maxLength: 20 }}
                value={formik.values.registrationNumber}
                onChange={(val) => {
                  formik.handleChange(val);
                }}
                onBlur={formik.registrationNumber}
                helperText={
                  formik.touched.registrationNumber &&
                  formik.errors.registrationNumber
                }
              />
            </div>

            <div className="control_group w_50">
              <label>Model</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={model}
                  onChange={(newValue) => {
                    setModel(newValue);
                  }}
                  maxDate={dayjs()}
                  openTo="year"
                  views={["year"]}
                  sx={{ minWidth: 250, width: "100%" }}
                />
              </LocalizationProvider>
              {error && !model ? (
                <p className="err_msg">Model is required</p>
              ) : (
                ""
              )}
            </div>
            {/* Cities */}
            <div className="control_group w_50">
              <label>Cities</label>
              <Select
                fullWidth
                labelId="Cities"
                name="Cities"
                value={selectedCities}
                displayEmpty
                onChange={handleCitiesChange}
              >
                <MenuItem disabled value="">
                  Select City
                </MenuItem>
                {cities?.length
                  ? cities?.map((item: any) => (
                      <MenuItem key={item?._id} value={item?._id}>
                        {item?.name?.en || ""}
                      </MenuItem>
                    ))
                  : null}
              </Select>
              {error && !selectedCities ? (
                <p className="err_msg">Cities is required</p>
              ) : (
                ""
              )}
            </div>
            <div className="control_group w_50">
              <label>Mileage (kmpl)</label>
              <TextField
                variant="outlined"
                placeholder="Mileage"
                fullWidth
                hiddenLabel
                className="text_field"
                name="mileage"
                id="mileage"
                inputProps={{ maxLength: 4 }}
                value={formik.values.mileage}
                onChange={(val) => {
                  if (isNumber(val.target.value)) {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.mileage}
                helperText={formik.touched.mileage && formik.errors.mileage}
              />
            </div>

            <div className="control_group w_50">
              <label>Delivery Fees</label>
              <TextField
                variant="outlined"
                placeholder="Delivery Fees"
                fullWidth
                hiddenLabel
                className="text_field"
                name="deliveryFees"
                id="deliveryFees"
                inputProps={{ maxLength: 4 }}
                value={formik.values.deliveryFees}
                onChange={(val) => {
                  if (isNumber(val.target.value)) {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.deliveryFees}
                helperText={
                  formik.touched.deliveryFees && formik.errors.deliveryFees
                }
              />
            </div>

            <div className="control_group w_50">
              <label>Security Charges </label>
              <TextField
                variant="outlined"
                placeholder="Security Charges"
                fullWidth
                hiddenLabel
                className="text_field"
                name="securityCharges"
                id="securityCharges"
                inputProps={{ maxLength: 4 }}
                value={formik.values.securityCharges}
                onChange={(val) => {
                  if (isNumber(val.target.value)) {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.securityCharges}
                helperText={
                  formik.touched.securityCharges &&
                  formik.errors.securityCharges
                }
              />
            </div>

            <div className="control_group w_50">
              <label>Return Charges</label>
              <TextField
                variant="outlined"
                placeholder="Return Charges"
                fullWidth
                hiddenLabel
                className="text_field"
                name="returnCharges"
                id="returnCharges"
                inputProps={{ maxLength: 4 }}
                value={formik.values.returnCharges}
                onChange={(val) => {
                  if (isNumber(val.target.value)) {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.returnCharges}
                helperText={
                  formik.touched.returnCharges && formik.errors.returnCharges
                }
              />
            </div>

            <div className="control_group w_50">
              <label>Extra Mileage Charge</label>
              <TextField
                variant="outlined"
                placeholder="Extra Mileage Charge"
                fullWidth
                hiddenLabel
                className="text_field"
                name="extraCharge"
                id="extraCharge"
                inputProps={{ maxLength: 4 }}
                value={formik.values.extraCharge}
                onChange={(val) => {
                  if (isNumber(val.target.value)) {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.extraCharge}
                helperText={
                  formik.touched.extraCharge && formik.errors.extraCharge
                }
              />
            </div>

            <div className="control_group w_50">
              <label>Vehicle Owner</label>
              <Select
                fullWidth
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedOwner}
                onChange={handleOwnerChange}
                displayEmpty
              >
                <MenuItem disabled value="">
                  Select Owner
                </MenuItem>

                <MenuItem value={"1"}>Admin</MenuItem>
                <MenuItem value={"2"}>User</MenuItem>
              </Select>
              {error && !selectedOwner ? (
                <p className="err_msg">Owner is required</p>
              ) : (
                ""
              )}
            </div>

            {selectedOwner === "2" ? (
              <div className="control_group w_50">
                <label>
                  Partners<span style={{ color: "red" }}>*</span>
                </label>
                <Select
                  fullWidth
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedUser}
                  onChange={handlePartnerChange}
                  displayEmpty
                  placeholder="Select Partner"
                  error={error && !selectedUser}
                >
                  <MenuItem disabled value="default">
                    {partnersLoading ? "Loading..." : "Select Partner"}
                  </MenuItem>
                  {partnersLoading ? null : partners.length === 0 ? (
                    <MenuItem disabled value="no-partners">
                      No partners found
                    </MenuItem>
                  ) : (
                    partners.map((partner: any) => (
                      <MenuItem key={partner._id} value={partner._id}>
                        {partner.partnerName ||
                          partner.partnerEmail ||
                          partner._id}
                      </MenuItem>
                    ))
                  )}
                </Select>
                {error && !selectedUser && selectedOwner === "2" && (
                  <FormHelperText error>Partner is required</FormHelperText>
                )}
              </div>
            ) : null}

            <div className="control_group w_100">
              <FormControlLabel
                control={<Checkbox />}
                checked={formik.values.isDepositRequired}
                name="isDepositRequired"
                onChange={formik.handleChange}
                label="Deposit Fees"
              />
            </div>

            <div
              className="control_group w_100"
              style={{ display: "flex", alignItems: "center", gap: 10 }}
            >
              <Checkbox
                name="isSubscription"
                checked={formik.values.isSubscription}
                onChange={(e) =>
                  formik.setFieldValue("isSubscription", e.target.checked)
                }
              />
              <p style={{ color: "#000000", fontWeight: "600" }}>
                Add for Subscription
              </p>
            </div>

            {formik?.values?.isDepositRequired ? (
              <>
                <div className="control_group w_50">
                  <label>Deposit Fees</label>
                  <TextField
                    variant="outlined"
                    placeholder="Deposit Fees"
                    fullWidth
                    hiddenLabel
                    className="text_field"
                    name="depositFee"
                    id="depositFee"
                    inputProps={{ maxLength: 4 }}
                    value={formik.values.depositFee}
                    onChange={(val) => {
                      if (isNumber(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                  />
                </div>
                <div className="control_group w_50" />
              </>
            ) : null}

            <div className="control_group w_50">
              <label>Description</label>
              <TextField
                variant="outlined"
                placeholder="Description"
                fullWidth
                hiddenLabel
                className="text_field"
                name="description"
                id="description"
                multiline
                minRows={4}
                value={formik.values.description}
                onChange={(val) => {
                  formik.handleChange(val);
                }}
              />
            </div>

            <div className="control_group w_100">
              <Card variant="outlined">
                <CardHeader
                  title={
                    <Box display="flex" alignItems="center" gap={2}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <CalendarMonth /> Availability & Pricing
                      </Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              selectedAvailability.length ===
                              availabilityOptions.length
                            }
                            onChange={handleAllAvailabilityChange}
                          />
                        }
                        label="All"
                        sx={{ ml: 2 }}
                      />
                    </Box>
                  }
                  subheader="Select rental periods and set pricing for each option"
                />
                <CardContent>
                  <Typography variant="subtitle1" gutterBottom>
                    Available Rental Periods
                  </Typography>
                  <Box
                    display="flex"
                    flexDirection="row"
                    gap={4}
                    flexWrap="nowrap"
                    mb={2}
                  >
                    {availabilityOptions.map((option) => (
                      <FormControlLabel
                        key={option.id}
                        control={
                          <Checkbox
                            checked={selectedAvailability.includes(option.id)}
                            onChange={() => handleAvailabilityChange(option.id)}
                          />
                        }
                        label={`${option.icon} ${option.label}`}
                        sx={{ mr: 2 }}
                      />
                    ))}
                  </Box>
                  {selectedAvailability.length > 0 && (
                    <Box mt={3}>
                      <Typography variant="subtitle2">
                        Selected Availability
                      </Typography>
                      <Box display="flex" gap={1} flexWrap="wrap" my={1}>
                        {selectedAvailability.map((id) => (
                          <Chip
                            key={id}
                            label={`${
                              availabilityOptions.find((opt) => opt.id === id)
                                ?.icon
                            } ${
                              availabilityOptions.find((opt) => opt.id === id)
                                ?.label
                            }`}
                            variant="outlined"
                          />
                        ))}
                      </Box>
                      <Typography
                        variant="subtitle1"
                        display="flex"
                        alignItems="center"
                        gap={1}
                        mt={2}
                        mb={1}
                      >
                        Set Pricing
                      </Typography>
                      <Grid container spacing={2}>
                        {selectedAvailability.map((id) => (
                          <Grid item xs={12} md={4} key={id}>
                            <TextField
                              placeholder={`${
                                availabilityOptions.find((opt) => opt.id === id)
                                  ?.label
                              } Price`}
                              type="text"
                              className="text_field"
                              fullWidth
                              hiddenLabel
                              variant="outlined"
                              value={pricing[id]?.price || ""}
                              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                const value = e.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                );
                                handlePricingChange(id, "price", value);
                              }}
                            />
                            <TextField
                              placeholder="Mileage Allowed per Rental (km)"
                              type="text"
                              className="text_field"
                              fullWidth
                              hiddenLabel
                              variant="outlined"
                              value={pricing[id]?.mileage || ""}
                              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                const value = e.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                );
                                handlePricingChange(id, "mileage", value);
                              }}
                              sx={{ mt: 2 }}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </div>

            <div className="control_group w_50">
              <label>Availability Start Date</label>
              <TextField
                variant="outlined"
                placeholder="Start Date"
                fullWidth
                type="date"
                hiddenLabel
                className="text_field"
                name="startDate"
                id="startDate"
                value={formik.values.startDate}
                onChange={(val) => {
                  formik.handleChange(val);
                }}
                inputProps={{
                  min: new Date().toISOString().split("T")[0],
                }}
              />
            </div>
            <div className="control_group w_50">
              <label>Availability End Date</label>
              <TextField
                variant="outlined"
                placeholder="End Date"
                fullWidth
                type="date"
                hiddenLabel
                className="text_field"
                name="endDate"
                id="endDate"
                value={formik.values.endDate}
                inputProps={{
                  min:
                    formik.values.startDate ||
                    new Date().toISOString().split("T")[0],
                }}
                onChange={(val) => {
                  formik.handleChange(val);
                }}
              />
            </div>
            {selectedOwner === "2" && (
              <>
                <div className="control_group w_33">
                  <label>Vehicle ownership document</label>
                  <div
                    style={{
                      position: "relative",
                      width: 400,
                      height: 200,
                      minWidth: 120,
                      minHeight: 120,
                      border: "1.5px solid #ccc",
                      borderRadius: 8,
                      background: "#f5f5f5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={vehicleDocUrl || "/static/images/picture.png"}
                      alt="vehicle doc"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: vehicleDocUrl ? "cover" : "contain",
                        borderRadius: 8,
                        background: "#f5f5f5",
                      }}
                    />
                    <label
                      htmlFor="vehicle-doc-upload"
                      style={{
                        position: "absolute",
                        bottom: 8,
                        left: "50%",
                        transform: "translateX(-50%)",
                        background: "#006039",
                        borderRadius: "50%",
                        width: 40,
                        height: 40,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        border: "2px solid #fff",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                        zIndex: 2,
                      }}
                    >
                      <Input
                        sx={{ display: "none" }}
                        id="vehicle-doc-upload"
                        type="file"
                        inputProps={{ accept: "image/png,image/jpeg" }}
                        onChange={handleVehicleDocUpload}
                      />
                      <img
                        src="/static/images/edit2_icon.svg"
                        alt="edit"
                        style={{ width: 24, height: 24 }}
                      />
                    </label>
                  </div>
                </div>
                <div className="control_group w_50">
                  <label>Vehicle Owner’s ID Proof Document</label>
                  <div
                    style={{
                      position: "relative",
                      width: 400,
                      height: 200,
                      minWidth: 120,
                      minHeight: 120,
                      border: "1.5px solid #ccc",
                      borderRadius: 8,
                      background: "#f5f5f5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={ownerDocUrl || "/static/images/picture.png"}
                      alt="owner doc"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: ownerDocUrl ? "cover" : "contain",
                        borderRadius: 8,
                        background: "#f5f5f5",
                      }}
                    />
                    <label
                      htmlFor="owner-doc-upload"
                      style={{
                        position: "absolute",
                        bottom: 8,
                        left: "50%",
                        transform: "translateX(-50%)",
                        background: "#006039",
                        borderRadius: "50%",
                        width: 40,
                        height: 40,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        border: "2px solid #fff",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                        zIndex: 2,
                      }}
                    >
                      <Input
                        sx={{ display: "none" }}
                        id="owner-doc-upload"
                        type="file"
                        inputProps={{ accept: "image/png,image/jpeg" }}
                        onChange={handleOwnerDocUpload}
                      />
                      <img
                        src="/static/images/edit2_icon.svg"
                        alt="edit"
                        style={{ width: 24, height: 24 }}
                      />
                    </label>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="form_end_btn">
            <Button
              className="btn btn_secondary"
              type="submit"
              onClick={() => {
                setError(true);
              }}
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default AddVehicle;
